export default "__VITE_ASSET__C7_lgBmL__"